import { useEffect, useState } from "react";
import { useLanguage } from "../../stores/LanguageStore";
import axios from "axios";
import { Group, Text } from "@mantine/core";
import { extractDomainFromUrl } from "../../api/ResellerAPI";

const versionMetaTagRegex = /<meta\s+name="version"\s+content="(\d+)"\s*\/>/;

const VersionController = () => {
  const lang = useLanguage((s) => s.language);
  const [needReload, setNeedReload] = useState(false);

  const handleRefresh = () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    });
    caches.keys().then((keyList) => {
      return Promise.all(
        keyList.map((key) => {
          return caches.delete(key);
        })
      );
    });
    setTimeout(() => {
      window.location.reload();
    }, 200);
  };

  useEffect(() => {
    let actualVersion = document.querySelector("meta[name='version']")?.content;
    setNeedReload(false);

    function doRequest() {
      axios
        .get(
          `https://${extractDomainFromUrl(
            window.location.href
          )}/index.html?timestamp=${new Date().getTime()}&actual_version=${actualVersion}`
        )
        .then((res) => {
          let newVersion = res.data.match(versionMetaTagRegex)[1];

          if (newVersion) {
            if (parseInt(newVersion) > parseInt(actualVersion)) {
              setNeedReload(true);
            }
          } else {
            setNeedReload(false);
          }
          setTimeout(doRequest, 5 * 60 * 1000);
        })
        .catch(() => {
          // Retry anyway
          setTimeout(doRequest, 5 * 60 * 1000);
        });
    }

    doRequest();
  }, []);

  return (
    <Group
      justify="center"
      p={8}
      px={12}
      bg={"primary.6"}
      pos={"fixed"}
      bottom={needReload ? 0 : -64}
      w={"100%"}
      style={{ zIndex: 100, transition: "all ease .3s" }}
    >
      <Text c={"#fcfbff"} fz={13}>
        ✨ {lang.header.alert.text1}{" "}
        <a
          onClick={handleRefresh}
          style={{
            fontWeight: "600",
            textDecoration: "underline",
            cursor: "pointer",
          }}
        >
          {lang.header.alert.refresh}
        </a>{" "}
        {lang.header.alert.text2} ✨
      </Text>
    </Group>
  );
};

export default VersionController;
